<template>
  <div class="home">
    <div class="home__header">
      <img class="home__logo" :src="images.logo" alt="">
      <h1>Поделиться корзиной</h1>
    </div>

    <div class="home__body">

      <div class="home__block home__block_app-descr">
        <h3 class="home__block-header">Важно</h3>
        <div style="font-style: italic; font-size: 15px;" class="home__block-body">
          <p>
            В случае возникновения вопросов и сложностей при установке приложения, пожалуйста, обратитесь к разработчику приложения любым удобным для вас способов.
          </p>
          <p>
            Мы готовы помочь вам с размещением кнопки "Поделиться", изменить тексты в всплывающих окнах и проконсультировать вас по любым вопросам связанным с работой приложения.
          </p>
          <p>
            <a style="margin-right: 10px;" href="https://t.me/+79967925862">Telegram</a>
            <a style="margin-right: 10px;" href="https://wa.me/+79967925862">Whatsapp</a>
            <a href="mailto:pateder@yandex.ru">pateder@yandex.ru</a>
          </p>
        </div>
      </div>

      <div class="home__block home__block_navigation">
        <h3 class="home__block-header">Содержимое:</h3>
        <div class="home__block-body">
          <ul>
            <li>
              <a href="#keys">Зачем?</a>
            </li>
            <li>
              <a href="#appd">Как работает приложение</a>
            </li>
            <li>
              <a href="#install">Установка приложения</a>
              <ul>
                <li>
                  <a href="#install">Установка</a>
                </li>
                <li>
                  <a href="#button">Добавление кнопки "Поделиться"</a>
                </li>
              </ul>
            </li>
<!--            <li>-->
<!--              <a href="#">Кнопка "Поделиться"</a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a href="#">Свои тексты и дизайн</a>-->
<!--            </li>-->
          </ul>
        </div>
      </div>

      <div id="keys" class="home__block home__block_app-descr">
        <h3 class="home__block-header">Кейсы</h3>
        <div class="home__block-body">
          <p>Примеры когда такой функционал будет полезен:</p>
          <ul>
            <li>домохозяйка сделала выбор товаров в вашем магазине и хочет, чтобы ее муж одобрил выбор и оплатил покупки.</li>
            <li>клиент хочет показать свои покупки другу, чтобы тот купил такие же товары</li>
            <li>Специалист поддержки магазина при общении с клиентом собирает корзину с теми товарами которые ему нужны и отправляем ссылку на уже сформированную корзину. Клиенту остается указать адрес доставки и оплатить.</li>
          </ul>
        </div>
      </div>

      <div id="appd" class="home__block home__block_app-descr">
        <h3 class="home__block-header">Как работает приложение</h3>
        <div class="home__block-body">
          <p>Приложения добавляем функционал в ваш интернет-магазин позволяющий пользователям делиться корзиной со своими друзьями, родственниками и близкими.</p>

          <p>После установки приложения и настройки приложения на странице корзины вашего интернет-магазина будет размещена кнопка "Поделиться корзиной"</p>

          <img :src="images.image_1" alt="">

          <p>При нажатии на кнопку пользователь получает ссылку на свою корзину. Скопировав ее он может отправить ссылку любому другому человеку</p>

          <img :src="images.image_2" alt="">

          <p>Получатель ссылки, перейдя по ней, увидит окошко с предложением загрузить состав корзины. Загрузив состав, в корзине появятся все те товары, которые были у отправителя на момент создания ссылки</p>

          <img :src="images.image_3" alt="">

          <p>Ссылка которая формируется при нажатии на "Поделиться корзиной" будет работать до тех пор. пока установлено приложение.</p>
        </div>
      </div>

      <div id="install" class="home__block home__block_app-descr">
        <h3 class="home__block-header">Установка приложения</h3>
        <div class="home__block-body">
          Информация со скриншотами добавится после размещения приложения в каталоге.
        </div>
      </div>

      <div id="button" class="home__block home__block_app-descr">
        <h3 class="home__block-header">Добавление кнопки "Поделиться"</h3>
        <div class="home__block-body">
          <p>После того как вы установили приложения из каталога необходимо разместить кнопку "Поделиться корзиной" на странице корзины вашего интернет магазина.</p>

          <p>Для размещения кнопки вы можете воспользоваться помочью разработчика (для этого свяжитесь с нами удобным для вас способом) или сделать самостоятельно.</p>

          <p><i>Кнопка "поделиться корзиной" должна содержать data-атрибут: <br> <b>data-share-care-button</b></i></p>

          <p>Ниже пример кода кнопки. Вы можете использовать данную кнопку или сделать свою.</p>

          <textarea style="resize: none;width: 100%; min-height: 70px;color: #e9edc0;background: #2d3842;padding: 10px;border-radius: 10px;" readonly>
            <button type="button" data-share-care-button style="margin-top: 10px; border: none; padding: 0; background: transparent; cursor: pointer;">
              <span style="display: block">Поделиться корзиной</span>
            </button>
          </textarea>

        </div>
      </div>




    </div>


  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      images: {
        logo: require('../assets/image/logo.svg'),
        image_1: require('../assets/image/1.png'),
        image_2: require('../assets/image/2.png'),
        image_3: require('../assets/image/3.png')
      }
    }
  }
}
</script>

<style lang="scss">
.home {
  display: block;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;

  padding: 50px 16px;

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  &__logo {
    width: 50px;
    height: auto;
    display: block;
    margin-right: 30px;
  }

  &__block {
    margin-bottom: 30px;
  }

  &__block-body {
    & img {
      max-width: 100%;
      width: 100%;

      display: block;
    }
  }
}
</style>
